__turbopack_context__.v({
  "languageList": "LanguageList-module__VbJtLG__languageList",
});
